import { Route, Routes } from 'react-router'
import { ForgotPassword } from './components/ForgotPassword'
import { TwoFactorAuth } from './components/TwoFactorAuth'
import { Login } from './components/Login'
import { AuthLayout } from './AuthLayout'
import { ChangePassword } from './components/ChangePassword'

const AuthPage = () => (
  <Routes>
    <Route element={<AuthLayout />}>
      <Route path='login' element={<Login />} />
      <Route path='forgot-password' element={<ForgotPassword />} />
      <Route path='two-factor-auth' element={<TwoFactorAuth />} />
      <Route path='change-password' element={<ChangePassword />} />
      <Route index element={<Login />} />
    </Route>
  </Routes>
)

export { AuthPage }
